<!-- <div class="container" *ngIf="auth.isLoading$ | async; else loaded">
    loading...
  </div> -->
<div #loaded>
    <p-toast key="notification" position="bottom-right">
        <ng-template let-message pTemplate="message">
            <app-notification [message]="message" style="flex-grow: 1;"></app-notification>
        </ng-template>
    </p-toast>
    <router-outlet></router-outlet>
</div>